import { useEffect } from 'react'
import { useGetUserCurrentTariffDetailsQuery } from '../../../api'
import { useAppDispatch, useAppSelector } from '../../../store/hooks/Redux'
import {
  selectSubRole,
  selectTariffDetails,
  setTariffDetails,
} from '../../../store/reducers/AuthSlice'

/** Держит тариф в сторе: подтягивает при монтировании и перезапрашивает после смены плана */
export const useTariffDetails = () => {
  const dispatch = useAppDispatch()
  const tariffDetails = useAppSelector(selectTariffDetails)
  const subRole = useAppSelector(selectSubRole)

  const { data: currentTariff, refetch: refetchTariff } = useGetUserCurrentTariffDetailsQuery(
    undefined,
    { skip: subRole === 'user' },
  )

  useEffect(() => {
    if (!currentTariff?.data) return

    const { project_details, ...rest } = currentTariff.data

    dispatch(
      setTariffDetails({
        ...rest,
        project_details: Object.entries(project_details ?? {}).map(([id, details]) => ({
          id,
          ...details,
        })),
      }),
    )
  }, [currentTariff])

  useEffect(() => {
    if (tariffDetails?.tariffUpdated && subRole !== 'user') {
      setTimeout(() => refetchTariff(), 2500)
    }
  }, [tariffDetails.tariffUpdated])
}
